import {$} from './util/$';
import {Modal} from './modal';

type MainmenuData = {
    title: string;
    body: string;
};

export function mainmenu(): void {
    const trigger: HTMLElement | undefined = $('.js-mainmenu-trigger');

    if (trigger === undefined) {
        return;
    }

    const data: MainmenuData = JSON.parse(
        <string>trigger.getAttribute('data-mainmenu'),
    );

    trigger.addEventListener('click', (): void => {
        Modal.open(data.title, data.body, 't-mainmenu', trigger, true);
    });
}
